import React, { useState } from "react";
import { Row, Col, Card } from "react-bootstrap";
import { Headings } from "../../atoms/Headings";
import Buttons from "../../atoms/Buttons";
import "./regularpayments.scss";
import { addCommas } from "../../helpers/helpers";
import { useNavigate } from "react-router-dom";
const RegularPayments = (props) => {
  const { regularPaymentsData } = props;
  const [isHovered, setIsHovered] = useState(true);

  const navigate = useNavigate();

  const handleMouseEnter = () => {
    setIsHovered(false);
  };
  const handleMouseLeave = () => {
    setIsHovered(true);
  };

  const manageRegularPayment = (event) => {
    event.preventDefault();
    let toggle = "drawdown";
    let combinedState = {
      toggle,
    };
    navigate("/manage?tab=investments", { state: combinedState });
  };
  const sanitizedRegularPaymentsData = regularPaymentsData?.map((payment) => ({
    startDate: payment.startDate || "01 Jan 3025",
    paymentAmount: payment.paymentAmount || 0,
    paymentFrequency: payment.paymentFrequency || "",
    taxFreeCashIncome: payment.taxFreeCashIncome || 0,
  }));
  const totalPaymentAmount = sanitizedRegularPaymentsData?.reduce(
    (total, payment) =>
      total + Number(payment.paymentAmount) + Number(payment.taxFreeCashIncome),
    0, //eslint-disable-line
  );
  // REMOVED AS PART OF USER STORY - 21440
  // const mostRecentDate = sanitizedRegularPaymentsData?.reduce(
  //   (latest, payment) => {
  //     const currentDate = new Date(payment?.startDate);
  //     return currentDate < new Date(latest) ? payment.startDate : latest;
  //   },
  //   sanitizedRegularPaymentsData[0].startDate, //eslint-disable-line
  // );
  const allFrequenciesSame = sanitizedRegularPaymentsData?.every(
    (payment) =>
      payment.paymentFrequency ===
      sanitizedRegularPaymentsData[0].paymentFrequency, //eslint-disable-line
  );
  const paymentFrequency = allFrequenciesSame
    ? sanitizedRegularPaymentsData[0].paymentFrequency
    : "Multiple";

  return (
    <>
      <Card className="regular-payment-card mb-4 mb-md-0">
        <Card.Body>
          <Card.Text className="custom-bottom-text">
            <Headings
              title="Regular payments"
              iconVariant="icon-sixteen-px"
              headIconName="payment"
              headIconVariant="icon-fourty-eight-px"
            />
            {regularPaymentsData?.length !== 0 ? (
              <div>
                {/* // REMOVED AS PART OF USER STORY - 21440
                // <Row className="mt-3" style={{ alignItems: "center" }}>
                  <Col xs={4} md={4} sm={4} lg={4}>
                    <span className="text-wrapper-span">Date</span>
                  </Col>
                  <Col
                    xs={8}
                    md={8}
                    sm={8}
                    lg={8}
                    className="rp-fields-wrapper"
                  >
                    <span className="text-wrapper-p">
                      {regularPaymentsData && regularPaymentsData.length > 0
                        ? mostRecentDate
                        : "DD MMM YYYY"}
                    </span>
                  </Col>
                </Row> */}
                <Row className="mt-1" style={{ alignItems: "center" }}>
                  <Col xs={4} md={4} sm={5} lg={4}>
                    <span className="text-wrapper-span">Amount</span>
                  </Col>
                  <Col
                    xs={8}
                    md={8}
                    sm={7}
                    lg={8}
                    className="rp-fields-wrapper"
                  >
                    <span className="text-wrapper-p">
                      {regularPaymentsData && regularPaymentsData.length > 0
                        ? `£${addCommas(Math.trunc(totalPaymentAmount))}`
                        : `£${addCommas(0.0)}`}
                      {regularPaymentsData &&
                        regularPaymentsData.length > 0 && (
                          <span className="rp-small-digit">
                            .{(totalPaymentAmount % 1).toFixed(2).substring(2)}
                          </span>
                        )}
                    </span>
                  </Col>
                </Row>
                <Row className="mt-1" style={{ alignItems: "center" }}>
                  <Col xs={4} md={4} sm={5} lg={4}>
                    <span className="text-wrapper-span">Frequency</span>
                  </Col>
                  <Col
                    xs={8}
                    md={8}
                    sm={7}
                    lg={8}
                    className="rp-fields-wrapper"
                  >
                    <span className="text-wrapper-p">
                      {regularPaymentsData && regularPaymentsData.length > 0
                        ? paymentFrequency
                        : "-"}
                    </span>
                  </Col>
                </Row>
              </div>
            ) : (
              <div className="mt-5">
                <Col>
                  <span className="text-wrapper-null">
                    You&apos;re not currently receiving any regular payments.
                    You can do this at any time and we&apos;ll show it here.
                  </span>
                </Col>
              </div>
            )}
            <Row>
              {regularPaymentsData?.length !== 0 ? (
                <Col className="mt-5">
                  <Buttons
                    name="Manage regular payments"
                    className="secondary mrp-btn"
                    iconname={isHovered ? "arrow-right" : "arrow-right-white"}
                    handleClick={manageRegularPayment}
                    variantname="icon-sixteen-px"
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                  ></Buttons>
                </Col>
              ) : (
                <Col className="mt-5">
                  <Buttons
                    name="Set up payments"
                    className="secondary mrp-btn"
                    iconname={isHovered ? "arrow-right" : "arrow-right-white"}
                    handleClick={manageRegularPayment}
                    variantname="icon-sixteen-px"
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                  ></Buttons>
                </Col>
              )}
            </Row>
          </Card.Text>
        </Card.Body>
      </Card>
    </>
  );
};
export default RegularPayments;
